export default "__VITE_ASSET__CXo31k0___"